export default {
  MAX_DESIGNS: 5,
  MAX_ICONS: 50,
  SNAPSHOT: 'ndx-snapshot',
  TIMESTAMP: 'ndx-timestamp',
  VALID_DURATION: 29 * (24 * 60 * 60 * 1000), // Days * Hours * Minutes * Seconds * Milliseconds
  VERSION: 'ndx-snapshot-version'
};
